import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClear = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 14l-1 1-4-4-4 4-1-1 4-4-4-4 1-1 4 4 4-4 1 1-4 4 4 4z"
  })
});
export default SvgClear;